module.exports = __webpack_public_path__ + "static/img/SCT1.0cb9944.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SCT1.svg
// module id = eomu
// module chunks = 43 119